import Link from "next/link";
import Image from "next/image";
import {getColor} from "@/styles/ThemeConfig";
import Stars from "@/components/base/Stars";
import LocationWhiteIcon from "../../../../public/images/location_icon_white.svg";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";


const TopRatedTourCard = styled.div`
    cursor: pointer;
    
    overflow: hidden;

    min-width: 100%;
    width: 100%;
    height: 370px;
    max-width: 470px;
    @media only screen and (${breakpoints.mobile}) {
        width: 100%;
        max-width: 290px;
        max-height: 255px;
    }

    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-image: url("${props => props.$image }");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    
    
    :hover{
        background-color: rgba(0,0,0,0.25);
        transition: ease-in-out 0.3s;

        .top_rated_tour_card_content p {
            max-height: 500px; /* Adjust this to a reasonable value */
            overflow: visible;
        }
    }

    .top_rated_tour_card_content p {
        max-height: 0;
        overflow: hidden;
        margin-top: 20px;
        transition: max-height 0.3s ease-in-out;
    }
`;


const TourTitle = styled.div`
    margin-bottom: 5px;
    color: ${getColor('gold')};
    font: 24px/32px "Playfair Display"!important;

    @media only screen and (${breakpoints.mobile}) {
        margin-bottom: 15px;
    }
`;



const TopRatedTourCardContent = styled.div`
    position:absolute;
    bottom: 0;
    width:100%;
    background-color: rgba(0,0,0,0.5);
    color: white;
    @media only screen and (${breakpoints.mobile}) {
        //bottom: -65px;
    }
    
    p{
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
    }
`;

export default function TourCard({item, ...rest}){
    return <ForceSSRLink prefetch={false} style={{textDecoration:'none', all:'unset'}} href={item?.slug ?? '#'} {...rest}>
        <TopRatedTourCard>
            <Image
                src={item?.cardImage?.url}
                alt={item?.title}
                width={470}
                height={370}
                style={{
                    width:'100%',
                    height:'100%',
                    objectFit:'cover',
                    zIndex:'-1',
                }}
            />

            <div
                style={{
                    position:'absolute',
                    top:'20px',
                    left:'20px',
                    color:getColor('yellow'),
                }}
            >
                <Stars size={30} numOfStars={item?.data?.info?.rating ?? 0}/>
            </div>

            <TopRatedTourCardContent className={'top_rated_tour_card_content'}>
                <div style={{
                    padding: '10px',
                }}>
                    <TourTitle>{item?.title}</TourTitle>
                    <div style={{
                        display:'flex',
                        alignItems:'center',
                        gap:'5px',
                    }}>
                        <Image src={LocationWhiteIcon} alt={'Location'} />
                        {item?.locationLabel}
                    </div>

                    <p dangerouslySetInnerHTML={{__html: ((item?.data?.info?.description || "").replace(/<\/?[^>]+(>|$)/g, "").slice(0, 200) + (item?.data?.info?.description?.length > 200 ? "..." : ""))}}/>

                </div>

            </TopRatedTourCardContent>


        </TopRatedTourCard>
    </ForceSSRLink>
}
